import { eventBus, type EventSubscription } from '../platform/eventBus';

export const BUDDY_RELATIONSHIP_CHANGED_EVENT =
  'BUDDY_RELATIONSHIP_CHANGED';

export type BuddyRelationshipChangeAction =
  | 'request'
  | 'cancel'
  | 'accept'
  | 'reject'
  | 'remove';

export interface BuddyRelationshipChange {
  relatedUserId: number;
  action: BuddyRelationshipChangeAction;
}

export const notifyBuddyRelationshipChanged = (
  change: BuddyRelationshipChange,
): void => {
  eventBus.emit(BUDDY_RELATIONSHIP_CHANGED_EVENT, change);
};

export const subscribeToBuddyRelationshipChanges = (
  listener: (change: BuddyRelationshipChange) => void,
): EventSubscription =>
  eventBus.addListener(BUDDY_RELATIONSHIP_CHANGED_EVENT, listener);
